import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const MIN_CHAT_WIDTH = 320;
const MAX_CHAT_WIDTH = 720;
const DEFAULT_CHAT_WIDTH = 420;

type UIState = {
  sidebarOpen: boolean;
  chatOpen: boolean;
  chatWidth: number;
  activePanel: 'layers' | 'bookmarks' | 'tools' | 'legend' | null;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  toggleChat: () => void;
  setChatOpen: (open: boolean) => void;
  setChatWidth: (width: number) => void;
  setActivePanel: (panel: UIState['activePanel']) => void;
};

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarOpen: true,
      chatOpen: true,
      chatWidth: DEFAULT_CHAT_WIDTH,
      activePanel: 'layers',
      toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleChat: () => set((s) => ({ chatOpen: !s.chatOpen })),
      setChatOpen: (open) => set({ chatOpen: open }),
      setChatWidth: (width) =>
        set({ chatWidth: Math.max(MIN_CHAT_WIDTH, Math.min(MAX_CHAT_WIDTH, width)) }),
      setActivePanel: (panel) => set({ activePanel: panel }),
    }),
    {
      name: 'rcmc-ui',
      partialize: (s) => ({
        sidebarOpen: s.sidebarOpen,
        chatOpen: s.chatOpen,
        chatWidth: s.chatWidth,
        activePanel: s.activePanel,
      }),
    },
  ),
);

export const CHAT_WIDTH_LIMITS = { min: MIN_CHAT_WIDTH, max: MAX_CHAT_WIDTH } as const;
